import { gql } from "@apollo/client";

export default gql`
    query coupon($id: uuid!) {
        coupon: subscription_coupon_by_pk(id: $id) {
            id
            code
            type
            value
            valid_from
            valid_till
            user_type
            list_of_users
            regions
            plans
            is_active
            created_at
        }
    }
`;
